import {API} from 'aws-amplify';

import {ENDPOINT} from '../constants';

class AnalyticsService {
  constructor() {
    if (AnalyticsService.instance) {
      return AnalyticsService.instance;
    }
    AnalyticsService.instance = this;
  }

  async createEvent(eventType, event) {
    const request = {
      body: {
        eventType,
        event,
      },
    };
    await API.post(ENDPOINT, `/analytics/events`, request);
  }
}

export default new AnalyticsService();
